<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyafirmafiyat from "@/models/satdosyafirmafiyat";

export default {
  mixins: [apibtoast, apigeneric, satdosyafirmafiyat],
  props: [
    "satdosyaId",
    "FirmaId",
    "Firmaadi",
    "Fiyatturu",
    "Yaklasikmaliyetdosyasi",
    "Kaydet",
  ],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: {},
      formattedValue: "0",
    };
  },
  components: {
    Loader,
  },
  watch: {
    satdosyaId() {},
    FirmaId() {
      this.Get();
    },
  },
  methods: {
    onSubmit() {
      const emptyId = "00000000-0000-0000-0000-000000000000";

      const postList = this.TableData.filter((x) => x.Id === emptyId).map(
        (x) => {
          const item = { ...x }; 
          delete item.Id; 
          return item;
        },
      );

      const putList = this.TableData.filter((x) => x.Id !== emptyId);

      const requests = [];

      if (postList.length > 0) {
        requests.push(this.Post("satdosyafirmafiyat/postlist", postList));
      }

      if (putList.length > 0) {
        requests.push(this.UpdateList("satdosyafirmafiyat/putlist", putList));
      }

      Promise.all(requests).then(() => {
        this.Get();
        this.$bvModal.hide("satdosyafirmafiyat");
        this.$emit("TableUpdate", 1);
      });
    },
    Get() {
      this.ActionsFilterGet({
        Service: "satdosyafirmafiyat/getgiris",
        Page: this.Page,
        Filter:
          "&Dosyaid=" +
          this.satdosyaId +
          "&Asc=Sirano&Dosyafirmaid=" +
          this.FirmaId +
          "&Fiyatturu=" +
          this.Fiyatturu,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="satdosyafirmafiyat"
      size="lg"
      :title="Firmaadi"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <b-button-group v-if="Yaklasikmaliyetdosyasi" class="mb-3">
          <b-button
            :href="this.$config.FILES_URL + 'Sat/' + Yaklasikmaliyetdosyasi"
            target="_blanl"
            v-tooltip="'Yaklaşık Maliyet Dosyası'"
            variant="primary"
          >
            <i class="far fa-eye "></i>
          </b-button>
        </b-button-group>

        <div class="table-responsive  ">
          <table class="table mb-0">
            <thead class="table-light">
              <tr>
                <th>{{ $t("satdosyafirmafiyat.Table.Sirano") }}</th>
                <th>{{ $t("satdosyafirmafiyat.Table.Malzemeid") }}</th>
                <th>{{ $t("satdosyafirmafiyat.Table.Adet") }}</th>
                <th v-if="!(Fiyatturu == 1 || Fiyatturu == 4)">
                  {{ $t("satdosyafirmafiyat.Table.Yerlimi") }}
                </th>
                <th>{{ $t("satdosyafirmafiyat.Table.TeklifFiyati") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="Data in TableData" :key="Data.Id">
                <th scope="row">{{ Data.Sirano }}</th>
                <th scope="row">{{ Data.Malzemeadi }}</th>
                <th scope="row">{{ Data.Adet }}</th>
                <th v-if="!(Fiyatturu == 1 || Fiyatturu == 4)" scope="row">
                  <b-form-checkbox
                    true-value="true"
                    false-value="false"
                    v-model="Data.Yerlimi"
                    class="mb-3"
                    checked
                    plain
                  ></b-form-checkbox>
                </th>
                <th scope="row">
                  <input
                    :Fiyatturudegistir="(Data.Fiyatturu = Fiyatturu)"
                    v-model="Data.Birimfiyat"
                    @input="
                      !Data.Birimfiyat
                        ? (Data.Birimfiyat = null)
                        : (Data.Deleted = false)
                    "
                    :disabled="
                      Yaklasikmaliyetdosyasi ||
                        !(Fiyatturu == 2 || Fiyatturu == 1 || Fiyatturu == 4)
                    "
                    type="number"
                    min="0"
                    step="0.0001"
                    class="form-control text-sm-end"
                  />
                </th>
              </tr>
            </tbody>
          </table>
          <br />
        </div>

        <button class="btn btn-primary" type="submit" v-if="Kaydet != false">
          {{ $t("satdosyafirmafiyat.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
